import Location from 'svg/Location';

interface Props {
  address: string;
}

export default function AddressRow({ address }: Props) {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <div className="flex items-center justify-center gap-2">
      <Location className="h-5 w-5 shrink-0 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="typography-product-link-large text-color-text-lightmode-primary underline dark:text-color-text-darkmode-primary"
      >
        {address}
      </a>
    </div>
  );
}
